import { api } from 'app/store';
import { CONTENT_ENDPOINTS } from 'api';
import { makeUseRequest } from 'hooks';
import { ContentEndpointInterfaces } from 'types';

export const useContent = <A extends CONTENT_ENDPOINTS>(path: A) =>
  makeUseRequest<ContentEndpointInterfaces[A]>(api.content.fetch.bind(api.configuration, path));
